import { Configuration } from '../app.constants'
import { Injectable } from '@angular/core'
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { StoreStatement } from '../models/profile.model';

@Injectable()
export class PlanService {
    constructor(private http: HttpClient) {
    }


    adminGetAllPlans(): any {
        return this.http.get(Configuration.apiUrl + 'api/plan/scaffold/GetAll')
    }

    adminGetAllActivePlans(): any {
        return this.http.get(Configuration.apiUrl + 'api/plan/scaffold/allActive')
    }

    adminAddFeatureToPlanSaffold(planId, featureId): any {
        return this.http.get(Configuration.apiUrl + 'api/plan/scaffold/add/feature?planId=' + planId + '&featureId=' + featureId)
    }

    adminRemoveFeatureToPlanSaffold(planId, featureId): any {
        return this.http.get(Configuration.apiUrl + 'api/plan/scaffold/remove/feature?planId=' + planId + '&featureId=' + featureId)
    }

    //o storeId é pego pelo contexto após estar logado
    adminGetAllPlanItensByStore(seoUrl: string = null): any {
        if (seoUrl != null) {
            return this.http.get(Configuration.apiUrl + 'api/plan/planitem/getall/store?seoName=' + seoUrl + '&polenTest=true')
        }
        else {
            return this.http.get(Configuration.apiUrl + 'api/plan/planitem/getall/store')
        }

    }

    adminGetAllFeatures(): any {
        return this.http.get(Configuration.apiUrl + 'api/plan/feature/getall')
    }

    adminGetPlanItem(planItemId, seoUrl: string = null): any {
        return this.http.get(Configuration.apiUrl + 'api/plan/planitem/get?planId=' + planItemId + '&seoName=' + seoUrl + '&polenTest=true')
    }

    adminSavePlanItem(planItem, seoUrl: string = null): any {
        console.log('salvar planItem')
        console.log(JSON.stringify(planItem))
        return this.http.post(Configuration.apiUrl + 'api/plan/planitem/save' + '?seoName=' + seoUrl + '&polenTest=true', JSON.stringify(planItem), {
            headers: new HttpHeaders().set('Content-Type', 'application/json')
        })
    }

    adminDeletePlanItem(planItemId, seoUrl: string = null): any {
        return this.http.get(Configuration.apiUrl + 'api/plan/planitem/delete?planId=' + planItemId + '&seoName=' + seoUrl + '&polenTest=true')
    }

    savePlanItemBankFee(planItemId, bankFee): any {
        debugger
        return this.http.post(Configuration.apiUrl + 'Api/plan/planitem/bankFee?id=' + planItemId, JSON.stringify(bankFee), {
            headers: new HttpHeaders().set('Content-Type', 'application/json')
        })
    }


    changeStorePlan(storeName, planTypeId): any {
        debugger
        console.log(Configuration.apiUrl + 'Api/Billing/ChangeStorePlan?storeName=' + storeName + '&planTypeId=' + planTypeId)
        return this.http.get(Configuration.apiUrl + 'Api/Billing/ChangeStorePlan?storeName=' + storeName + '&planTypeId=' + planTypeId)
    }


    updatePlan(statement): any {
        return this.http.post(Configuration.apiUrl + 'Api/Finance/adminUpdatePlan', JSON.stringify(statement), {
            headers: new HttpHeaders().set('Content-Type', 'application/json')
        })
    }

    adminFixTotalPrice(orderId): any {
        return this.http.get(Configuration.apiUrl + 'Api/FixError/FixTotalPrice?orderId=' + orderId)
    }

    getActivePlans(): any {
        return this.http.get(Configuration.apiUrl + 'Api/Dashboard/activePlans')
    }

    savePlan(plan): any {
        return this.http.post(Configuration.apiUrl + 'Api/Dashboard/SavePlan', JSON.stringify(plan), {
            headers: new HttpHeaders().set('Content-Type', 'application/json')
        })
    }

}
